import api from './abstract';

const tokenApi = {
    getToken() {
        return api.get('/token/access-token');
    }
};

export default tokenApi;